import axios from '@/axios';
// import * as types from '../mutation-types';
import { downloadBlob } from '@/utils/functions';

export default {
    namespaced: true,

    state: {

    },

    actions: {
        fetchExcelAttnEmp(_,  { employeeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeeWorkDays', { 
                params: { employeeId, dateFrom, dateTo }, 
                responseType: 'blob'  
            }).then(({ data }) => {
                // return data
                downloadBlob(data, `EmployeeWorkDays ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelLeaveEmp(_, { employeeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeeLeaves', { params: { employeeId, dateFrom, dateTo }, responseType: 'blob' }).then(({ data }) => {
                downloadBlob(data, `EmployeeLeaves ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelPermissionEmp(_, { employeeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeePermissioins', { params: { employeeId, dateFrom, dateTo }, responseType: 'blob' }).then(({ data }) => {
                downloadBlob(data, `EmployeePermissioins ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelTaskEmp(_, { employeeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeeTasks', { params: { employeeId, dateFrom, dateTo }, 
                responseType: 'blob' }).then(({ data }) => {
                    downloadBlob(data, `EmployeeTasks ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelAttn(_, { dateFrom, dateTo, AttendType, EmployeeIds, NameOrNum, Code, IsNightShift, PermenantSystemId, SectionId, OrderByCode, OrderByLate, OrderByEarlyLeave, OrderByOverTime, Valid }) {
            return axios.get('Reports/Export/EmployeesWorkDays', { 
                params: {
                    dateFrom, dateTo, AttendType, EmployeeIds, NameOrNum, Code, IsNightShift, PermenantSystemId, SectionId, OrderByCode, OrderByLate, OrderByEarlyLeave, OrderByOverTime, Valid 
                }, 
                responseType: 'blob'  
            }).then(({ data }) => {
                downloadBlob(data, `EmployeesWorkDays ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
           
        },

        fetchExcelLeave(_, { typeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeesLeaves', { params: { typeId, dateFrom, dateTo }, responseType: 'blob' }).then(({ data }) => {
                downloadBlob(data, `EmployeesLeaves ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelPermissions(_, { typeId ,dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeesPermissions', { params: { typeId, dateFrom, dateTo }, responseType: 'blob' }).then(({ data }) => {
                downloadBlob(data, `EmployeesPermissions ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },

        fetchExcelTasks(_, { taskTypeId, dateFrom, dateTo }) {
            return axios.get('Reports/Export/EmployeesTasks', { params: { taskTypeId, dateFrom, dateTo }, responseType: 'blob' }).then(({ data }) => {
                downloadBlob(data, `EmployeesTasks ${new Date().toISOString().slice(0, 10)}.xlsx`);
            })
        },
    }
}